/** Kannada: getting in and finding: language choice, sign-in, the menu, Find, My card, the job list. */
export const screens = {
    "onboard.title": "ನಿಮ್ಮ ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    "onboard.later": "ನಂತರ “ನನ್ನ ಬಗ್ಗೆ”ಯಲ್ಲಿ ಬದಲಾಯಿಸಬಹುದು.",
    "onboard.continue": "ಮುಂದುವರಿಸಿ",
    "signin.label": "ಸೈನ್ ಇನ್",
    "signin.headline": "ನಿಮ್ಮ ಏಜೆಂಟ್, ನಿಮ್ಮ ಫೋನ್.",
    "signin.soft": "ನಿಮ್ಮ ನಂಬರ್ ನಿಮ್ಮದೇ ಆಗಿರುತ್ತದೆ.",
    "signin.consumer": "ನನಗೆ ಕೆಲಸ ಮಾಡಿಸಬೇಕು",
    "signin.worker": "ನಾನು ಕೆಲಸ ಮಾಡುತ್ತೇನೆ",
    "signin.language": "ಭಾಷೆ: {lang}",
    "signin.change": "ಬದಲಿಸಿ",
    "signin.name": "ನಿಮ್ಮ ಹೆಸರು",
    "signin.phone": "ಮೊಬೈಲ್ ನಂಬರ್",
    "signin.err_phone": "ನಿಮ್ಮ 10 ಅಂಕಿಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆಯನ್ನು ಬರೆಯಿರಿ.",
    "signin.code": "ಎಸ್‌ಎಂಎಸ್‌ನಲ್ಲಿ ಬಂದ ಕೋಡ್",
    "signin.code_dev": "ಎಸ್‌ಎಂಎಸ್‌ನಲ್ಲಿ ಬಂದ ಕೋಡ್ (ಡೆವ್: {code})",
    "signin.send_code": "ಕೋಡ್ ಕಳುಹಿಸಿ",
    "signin.submit": "ಸೈನ್ ಇನ್ ಮಾಡಿ",
    "role.worker": "ಕೆಲಸಗಾರರು",
    "role.customer": "ಗ್ರಾಹಕರು",
    "nav.find": "ಹುಡುಕಿ",
    "nav.my_jobs": "ನನ್ನ ಕೆಲಸಗಳು",
    "nav.card": "ನನ್ನ ಕಾರ್ಡ್",
    "shell.sign_out": "ಸೈನ್ ಔಟ್",
    "trail.to_decide": "{count} ನಿರ್ಧಾರ ಬಾಕಿ",
    "find.headline": "ನಿಮ್ಮ ಸುತ್ತಮುತ್ತ ಯಾರು ಸಹಾಯ ಮಾಡಬಹುದು.",
    "find.soft": "ನಿಮ್ಮ ಬಜೆಟ್ ಈ ಫೋನ್‌ನಲ್ಲೇ ಇರುತ್ತದೆ.",
    "find.area": "ಏರಿಯಾ",
    "find.within_km": "{km} ಕಿ.ಮೀ. ಒಳಗೆ",
    "find.distance": "{km} ಕಿ.ಮೀ.",
    "find.from": "{price} ರಿಂದ",
    "find.when": "ಯಾವಾಗ",
    "find.ask.one": "{count} ಕೆಲಸಗಾರರನ್ನು ಕೇಳಿ",
    "find.ask.other": "{count} ಕೆಲಸಗಾರರನ್ನು ಕೇಳಿ",
    "card.headline": "ಜನರು ನಿಮ್ಮನ್ನು ಹುಡುಕಲಿ.",
    "card.soft": "ನಿಮ್ಮ ಕನಿಷ್ಠ ಬೆಲೆ ಈ ಫೋನ್‌ನಲ್ಲೇ ಇರುತ್ತದೆ.",
    "card.what": "ನನ್ನ ಕೆಲಸ",
    "card.where": "ಕೆಲಸದ ಏರಿಯಾ",
    "card.rate": "ಸಾಮಾನ್ಯ ದರ, ₹ (ಬೋರ್ಡ್‌ನಲ್ಲಿ ಕಾಣುತ್ತದೆ)",
    "card.min": "ನಾನು ಒಪ್ಪುವ ಕನಿಷ್ಠ ಬೆಲೆ, ₹ (ಖಾಸಗಿ)",
    "card.about": "ನನ್ನ ಕೆಲಸದ ಬಗ್ಗೆ",
    "card.about_example": "10 ವರ್ಷ, ವೈರಿಂಗ್ ಮತ್ತು ಫ್ಯಾನ್",
    "card.languages": "ನಾನು ಮಾತನಾಡುವ ಭಾಷೆಗಳು",
    "card.ask_first": "{item} ಇದ್ದರೆ ಬೆಲೆ ಹೇಳುವ ಮೊದಲು ನನ್ನನ್ನು ಕೇಳಿ",
    "card.auto": "ನನ್ನ ಬೆಲೆಗಳ ಒಳಗೆ ಏಜೆಂಟ್ ತಾನೇ ಒಪ್ಪಂದಕ್ಕೆ ಸಹಿ ಮಾಡಲಿ",
    "card.band_use": "ನಿಮ್ಮ ಏಜೆಂಟ್ ಪ್ರತಿ ಕೆಲಸದ ಬೆಲೆಯನ್ನು ಈ ದರದಿಂದ ಯೋಜಿಸುತ್ತದೆ ಮತ್ತು ನಿಮ್ಮ ಕನಿಷ್ಠ ಬೆಲೆಗಿಂತ ಕೆಳಗೆ ಹೋಗುವುದಿಲ್ಲ.",
    "card.on_board": "ಬೋರ್ಡ್‌ನಲ್ಲಿ: {area} – {trades}, {price} ರಿಂದ",
    "card.off_board": "ಬೋರ್ಡ್‌ನಿಂದ ತೆಗೆಯಲಾಗಿದೆ",
    "card.publish": "ನನ್ನ ಕಾರ್ಡ್ ಬೋರ್ಡ್‌ಗೆ ಹಾಕಿ",
    "card.unlist": "ನನ್ನ ಕಾರ್ಡ್ ಬೋರ್ಡ್‌ನಿಂದ ತೆಗೆಯಿರಿ",
    "card.err_trade": "ಕನಿಷ್ಠ ಒಂದು ಕೆಲಸ ಆಯ್ಕೆಮಾಡಿ, ಅಥವಾ ನಿಮ್ಮ ಕೆಲಸ ಸೇರಿಸಿ.",
    "card.err_rate": "ಸಾಮಾನ್ಯ ದರ ನಿಮ್ಮ ಕನಿಷ್ಠ ಬೆಲೆಗಿಂತ ಕಡಿಮೆ ಇರಬಾರದು.",
    "requests.checked": "ಕೊನೆಯ ಪರಿಶೀಲನೆ: {time}",
    "error.generic": "ಏನೋ ತಪ್ಪಾಗಿದೆ. ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
    "a11y.deal": "ಒಪ್ಪಂದ",
    "a11y.contact": "ಸಂಪರ್ಕ",
    "a11y.notes": "ಸಂದೇಶಗಳು",
    "a11y.payment": "ಪಾವತಿ",
    "a11y.plan": "ಪ್ಲಾನ್",
    "a11y.approve": "ರಿಕ್ವೆಸ್ಟ್ ಒಪ್ಪಿ",
    "a11y.answer": "ಕೆಲಸಗಾರರಿಗೆ ಉತ್ತರಿಸಿ",
    "a11y.sign": "ಒಪ್ಪಂದಕ್ಕೆ ಸಹಿ ಮಾಡಿ",
    "a11y.confirm_payment": "ಪಾವತಿ ಖಚಿತಪಡಿಸಿ",
    "a11y.pay": "ಪಾವತಿಸಿ",
    "a11y.review": "ಅಭಿಪ್ರಾಯ",
    "a11y.stars": "ನಕ್ಷತ್ರಗಳು",
    "a11y.review_text": "ಅಭಿಪ್ರಾಯದ ಬರಹ",
    "a11y.utr": "ಯುಪಿಐ ರೆಫರೆನ್ಸ್",
    "a11y.qr": "ಯುಪಿಐ ಕ್ಯೂಆರ್ ಕೋಡ್",
    "a11y.job_with": "{name} ಅವರೊಂದಿಗಿನ ಕೆಲಸ",
    "a11y.worker": "ಕೆಲಸಗಾರರು {name}",
    "a11y.ask_worker": "{name} ಅವರನ್ನು ಕೇಳಿ",
    "a11y.ask_workers": "ಕೆಲಸಗಾರರನ್ನು ಕೇಳಿ",
    "a11y.my_card": "ನನ್ನ ಕಾರ್ಡ್",
    "a11y.role": "ಪಾತ್ರ",
    "a11y.language": "ಭಾಷೆ",
    "a11y.note": "ಗ್ರಾಹಕರಿಗೆ ಸಂದೇಶ",
    "a11y.send": "ಕಳುಹಿಸಿ",
};
//# sourceMappingURL=screens.js.map